import {
  insertIntoSupabase,
  updateInSupabase,
  deleteFromSupabase,
  selectTrackingRange,
} from "../helpers/supabase-api";

export function createTrackingElement(elementData) {
  return insertIntoSupabase('tracking_elements', elementData);
}

/**
 * Best-effort upsert using update-then-insert fallback.
 * This keeps UI-edited elements and tracking_elements in sync.
 */
export async function upsertTrackingElement(filters, elementData) {
  const updated = await updateInSupabase('tracking_elements', elementData, filters);
  if (Array.isArray(updated) && updated.length > 0) {
    return updated[0];
  }
  return createTrackingElement(elementData);
}

export function updateTrackingElement(filters, data) {
  return updateInSupabase('tracking_elements', data, filters);
}

export function deleteTrackingElement(filters) {
  return deleteFromSupabase('tracking_elements', filters);
}

export function getTrackingRange(from, to, select = '*') {
  return selectTrackingRange(from, to, select).then(data => ({ data }));
}
